module.exports = __webpack_public_path__ + "mainassets/img/comet.ccc8148e.svg";